import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";
import { ChevronRight, Plus, Settings, ShieldAlert } from "lucide-react";
import { ONB_STATUS, PAY_STATUS, LINK_STATE, Pill } from "../../components/onboarding/adminUi";
import { CreateOnboardingDialog } from "../../components/onboarding/CreateOnboardingDialog";
import { WelcomeSettingsDialog } from "../../components/onboarding/WelcomeSettingsDialog";
import { btn, fmtDate } from "../../components/leads/PriorityBadge";

const Row = ({ o }) => (
  <Link to={`/app/admin/incorporaciones/${o.id}`} data-testid={`onb-item-${o.id}`}
    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.06)", color: "#fff", textDecoration: "none" }}>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        {o.player_name}
        {o.health_review?.needed && <span title="Salud: revisión humana" style={{ color: "#f87171", display: "inline-flex" }} data-testid={`onb-health-flag-${o.id}`}><ShieldAlert size={15} /></span>}
        <Pill map={ONB_STATUS} k={o.status} testid={`onb-status-${o.id}`} />
        <Pill map={PAY_STATUS} k={o.payment_status} />
        <Pill map={LINK_STATE} k={o.link_state} />
      </div>
      <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 4 }}>
        {o.plan_name} · {o.duration_months} {o.duration_months === 1 ? "mes" : "meses"} · {o.email || "sin email"} · Creada {fmtDate(o.created_at)}
      </div>
    </div>
    <ChevronRight size={18} style={{ color: "#737373", flexShrink: 0 }} />
  </Link>
);

export default function AdminOnboardings() {
  const [items, setItems] = useState(null);
  const [create, setCreate] = useState(false);
  const [settings, setSettings] = useState(false);
  React.useEffect(() => { api.get("/admin/onboardings").then((r) => setItems(r.data)).catch((e) => { toast.error(formatErr(e)); setItems([]); }); }, []);

  return (
    <AppShell>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Incorporaciones</h1>
          <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 0" }}>Enlaces personales y formulario completo de cada nuevo cliente.</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => setSettings(true)} style={btn("transparent")} data-testid="onb-open-settings"><Settings size={14} /> Mensaje predeterminado</button>
          <button onClick={() => setCreate(true)} style={btn("#dc2626")} data-testid="onb-open-create"><Plus size={14} /> Nueva incorporación</button>
        </div>
      </div>
      <div style={{ background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 4 }} data-testid="onb-list">
        {items === null && <div style={{ padding: 24, textAlign: "center", color: "#a3a3a3" }}>Cargando…</div>}
        {items?.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#a3a3a3" }} data-testid="onb-empty">Aún no hay incorporaciones.</div>}
        {items?.map((o) => <Row key={o.id} o={o} />)}
      </div>
      <CreateOnboardingDialog open={create} onOpenChange={setCreate} />
      <WelcomeSettingsDialog open={settings} onOpenChange={setSettings} />
    </AppShell>
  );
}
